































import { defineComponent } from '@vue/composition-api';

const StickyFooterActionBar = defineComponent({
  props: {
    show: {
      default: true,
    },
    title: { default: '' },
    subtitle: { default: '' },
    actionText: { default: 'ตกลง' },
    cancelText: { default: 'ยกเลิก' },
    icon: { default: null },
    type: { default: 'submit' },
    heightClass: { default: 'h-24' },
    iconClass: { default: 'w-10' },
    hideCancel: { default: false },
  },
  // setup() {},
});

export default StickyFooterActionBar;
